import OneScreen from './layouts/OneScreen.vue'
import VueRouter from 'vue-router';

const routes=[
  {
    name: '',
    path: '*',
    component: OneScreen
  }
]

export default new VueRouter({
  routes,
  mode: 'history'
});